import React from 'react';

const EmptyAcceptedAppSvg = () => {
    return (
        <svg width="150" height="151" viewBox="0 0 150 151" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_24243_45955)">
                <path
                    d="M9.125 43.625H127.625V131.375C127.625 134.689 124.939 137.375 121.625 137.375H15.125C11.8113 137.375 9.125 134.689 9.125 131.375V43.625Z"
                    fill="#EFF3F9"
                />
                <path
                    d="M127.75 101.375V121.625C127.75 123.844 127.281 125.969 126.468 127.875C124.031 133.375 118.531 137.25 112.125 137.25H24.6247C4.87476 141 8.99966 130.25 8.99966 121.625V43.5H18.3747V121.625C18.3747 125.063 21.1872 127.875 24.6247 127.875H84.1872C84.0622 126.844 83.9997 125.813 83.9997 124.75C83.9997 117.291 86.9628 110.137 92.2373 104.863C97.5117 99.5882 104.665 96.625 112.125 96.625C117.906 96.625 123.281 98.375 127.75 101.375Z"
                    fill="#CFE0F3"
                />
                <rect x="25.5" y="60.75" width="18.75" height="18.75" rx="3" fill="#B6CAE5" />
                <rect x="59.25" y="60.75" width="18.75" height="18.75" rx="3" fill="#B6CAE5" />
                <rect x="93" y="60.75" width="18.75" height="18.75" rx="3" fill="#B6CAE5" />
                <rect x="25.5" y="94.5" width="18.75" height="18.75" rx="3" fill="#B6CAE5" />
                <rect x="59.25" y="94.5" width="18.75" height="18.75" rx="3" fill="#B6CAE5" />
                <rect x="93" y="94.5" width="18.75" height="18.75" rx="3" fill="#B6CAE5" />
            </g>
            <g clip-path="url(#clip1_24243_45955)">
                <path d="M9 21.75C9 18.4363 11.6863 15.75 15 15.75H121.748C125.061 15.75 127.747 18.4363 127.747 21.75V43.875H9V21.75Z" fill="#19B836" />
                <path
                    d="M21.375 15.7498C17.231 15.7498 13.4302 13.1948 10.4999 16.1251C7.56966 19.0553 9.14413 27.3561 9.14413 31.5001V44.0001H18.5191V28.3751C18.5191 23.2408 17.5531 18.5967 21.375 15.7498Z"
                    fill="#10A92C"
                />
            </g>
            <path
                d="M115.25 150.5C129.058 150.5 140.25 139.307 140.25 125.5C140.25 111.693 129.058 100.5 115.25 100.5C101.443 100.5 90.2505 111.693 90.2505 125.5C90.2505 139.307 101.443 150.5 115.25 150.5Z"
                fill="#10A92C"
            />
            <path
                d="M115.25 144.25C125.605 144.25 134 135.855 134 125.5C134 115.145 125.605 106.75 115.25 106.75C104.895 106.75 96.5 115.145 96.5 125.5C96.5 135.855 104.895 144.25 115.25 144.25Z"
                fill="#19B836"
            />
            <path
                d="M112.125 134.875C111.715 134.875 111.309 134.794 110.929 134.637C110.55 134.48 110.206 134.25 109.916 133.959L103.666 127.709C103.08 127.123 102.751 126.328 102.751 125.5C102.751 124.671 103.08 123.876 103.666 123.29C104.252 122.704 105.047 122.375 105.875 122.375C106.704 122.375 107.499 122.704 108.085 123.29L112.125 127.331L122.416 117.04C122.706 116.75 123.051 116.52 123.43 116.363C123.809 116.206 124.215 116.125 124.625 116.125C125.036 116.125 125.442 116.206 125.821 116.363C126.2 116.52 126.545 116.75 126.835 117.04C127.125 117.33 127.355 117.675 127.512 118.054C127.669 118.433 127.75 118.839 127.75 119.25C127.75 119.66 127.669 120.066 127.512 120.445C127.355 120.824 127.125 121.169 126.835 121.459L114.335 133.959C114.045 134.25 113.701 134.48 113.322 134.637C112.942 134.794 112.536 134.875 112.125 134.875Z"
                fill="#EFF3F9"
            />
            <path
                d="M46.25 12.25C46.25 8.79822 43.4518 6 40 6C36.5482 6 33.75 8.79822 33.75 12.25V21.625C33.75 25.0768 36.5482 27.875 40 27.875C43.4518 27.875 46.25 25.0768 46.25 21.625V12.25Z"
                fill="#CFE0F3"
            />
            <path
                d="M102.5 12.25C102.5 8.79822 99.7018 6 96.25 6C92.7982 6 90 8.79822 90 12.25V21.625C90 25.0768 92.7982 27.875 96.25 27.875C99.7018 27.875 102.5 25.0768 102.5 21.625V12.25Z"
                fill="#CFE0F3"
            />
            <path
                d="M39.999 6V15.375C39.999 17.0326 40.6575 18.6223 41.8296 19.7944C43.0017 20.9665 44.5914 21.625 46.249 21.625V12.25C46.249 10.5924 45.5905 9.00268 44.4184 7.83058C43.2463 6.65848 41.6566 6 39.999 6ZM96.249 6V15.375C96.249 17.0326 96.9075 18.6223 98.0796 19.7944C99.2517 20.9665 100.841 21.625 102.499 21.625V12.25C102.499 10.5924 101.841 9.00268 100.668 7.83058C99.4963 6.65848 97.9066 6 96.249 6Z"
                fill="#EFF3F9"
            />
            <defs>
                <clipPath id="clip0_24243_45955">
                    <rect width="118.75" height="93.75" fill="white" transform="translate(9 43.625)" />
                </clipPath>
                <clipPath id="clip1_24243_45955">
                    <path d="M9 21.75C9 18.4363 11.6863 15.75 15 15.75H121.748C125.061 15.75 127.747 18.4363 127.747 21.75V43.875H9V21.75Z" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default EmptyAcceptedAppSvg;
